import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function DoublePicture({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M10.9202 21C10.9702 20.66 10.9902 20.33 11.0002 20C11.0002 16.13 7.86021 13 4.00021 13C3.66021 13 3.32921 13.02 2.99921 13.08M7.00021 7V6C7.00021 4.34 8.34021 3 10.0002 3H18.0002C19.6502 3 21.0002 4.34 21.0002 6V14C21.0002 15.65 19.6502 17 18.0002 17H17.0002M12.4602 11.46V11.45C12.4702 11.43 12.5102 11.43 12.5302 11.45C12.5402 11.46 12.5402 11.5 12.5202 11.52C12.5002 11.53 12.4602 11.53 12.4402 11.51C12.4202 11.49 12.4202 11.45 12.4402 11.43M3.00021 10.11V17.88C2.99921 19.59 4.39021 20.99 6.11021 20.99H13.8802C15.5902 20.99 16.9902 19.59 16.9902 17.87V10.09C16.9902 8.37 15.5902 6.97 13.8702 6.97H6.09021C4.37021 6.97 2.97021 8.36 2.97021 10.08L3.00021 10.11Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default DoublePicture;